module.exports = "https://static.wmbcdn.com/uniweb/images/fea2d2354a880c48b331b6458b66f0f7.svg";